import React from "react";
import "./Title.css";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    titleClass: {
        marginLeft: "5%",
        marginTop: "5%",
        [theme.breakpoints.up('lg')]: {
            marginLeft: "10%",
            marginTop: "2%"
        },
        [theme.breakpoints.up('xl')]: {
            marginLeft: "20%",
            marginTop: "2%"
        },
    }

}));

const Title = (props) => {
    let title = props.title;
    let subtitle = props.subtitle;
    const classes = useStyles();

    return (
        <React.Fragment>
            <div className={classes.titleClass}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                    }}
                >
                    <div className="vertical-line" style={{marginRight: "15px"}}/>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <p className="title font-face-encode-sans-light">{title}</p>
                        <p className="subtitle font-face-encode-sans-bold">{subtitle}</p>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Title;
